import { render, staticRenderFns } from "./AccountNotificationConventions.vue?vue&type=template&id=5a677035&scoped=true"
import script from "./AccountNotificationConventions.vue?vue&type=script&lang=js"
export * from "./AccountNotificationConventions.vue?vue&type=script&lang=js"
import style0 from "./AccountNotificationConventions.vue?vue&type=style&index=0&id=5a677035&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a677035",
  null
  
)

export default component.exports